<template>
  <div class="inline-form">
    <el-select
      v-model="selectData.company"
      placeholder="请选择公司"
      :disabled="disabled"
      :clearable="clearable"
      :filterable="filterable"
      style="width: 300px;"
      @change="changeCompany"
    >
      <el-option
        v-for="(item, i) in dataList"
        :key="i"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <el-select
      v-model="selectData.department"
      placeholder="请选择部门"
      :disabled="disabled"
      :multiple="multiple"
      :clearable="clearable"
      :filterable="filterable"
      style="width: 200px;"
      @change="changeDepartment"
    >
      <el-option
        v-for="(item, i) in departmentList"
        :key="i"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import FormConfig from "../formConfig"; // 表单配置
// 所属公司及部门
export default {
  name: "CompanyDepartments",
  props: {
    value: {
      type: [String, Number, Array, Object],
      default: ""
    }
  },
  data() {
    return {
      dataModel: this.value,
      size: FormConfig.config.size,
      // 选择的公司和部门
      selectData: {
        company: "",
        department: ""
      },
      departmentList: [] // 部门列表
    };
  },
  computed: {
    disabled() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.disabled;
      return status;
    },
    multiple() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.multiple;
      return status;
    },
    clearable() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.clearable;
      return status;
    },
    filterable() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.filterable;
      return status;
    },
    dataList() {
      return workFlowConfig.companyList;
    }
  },
  watch: {
    value(val) {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      this.dataModel = this.value;
      if (!this.value) {
        return;
      }
      this.selectData = _.cloneDeep(this.value);
      this.changeCompany(this.selectData.company);
    },
    // 选择公司
    changeCompany(value) {
      let item = _.find(this.dataList, { value });
      let departmentList = item.children || [];
      this.departmentList = departmentList;
    },
    // 选择部门
    changeDepartment(e) {
      this.$emit("input", this.selectData);
    }
  }
};
</script>
<style lang="less" scoped>
.inline-form {
  /deep/.el-select {
    margin-right: 10px;
  }
}
</style>
